import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { OnboardingFacadeService } from "@ui/components/auth/onboarding-form/services/onboarding-facade.service";

@Injectable({
  providedIn: "root",
})
export class OnboardingRegisterGuard implements CanActivate {
  private readonly onboardingFacade = inject(OnboardingFacadeService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.onboardingFacade.pinValidated()) {
      return true;
    }

    const token = route.paramMap.get("token");
    if (token) {
      this.router.navigate(["/onboarding", token, "pin"]);
      return false;
    }

    this.router.navigate(["/login"]);
    return false;
  }
}
